import { gql } from 'graphql-request';

export const getPipelineRunQuery = gql`
  query GetPipelineRun($eventId: String!) {
    pipelineRun(eventId: $eventId) {
      event
      rawStatus
      status
      failureReason
      eventTimestamp
      syncId
      taskType
      rescheduledAt
      connectorName
      connectorType
      toolType
      connectorId
      destination
    }
  }
`;
